import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

function formatMoney(val) {
  if (Number.isInteger(val)) return String(val);
  return String(val.toFixed(2)).replace(".", ",");
}

export function generateTask() {
  const a = Math.floor(Math.random() * 4) + 3; // 3..6 zl/km
  const b = Math.floor(Math.random() * 8) + 7; // 7..14 zl oplata startowa
  const x = Math.floor(Math.random() * 10) + 4; // 4..13 km
  const y = a * x + b;

  return {
    type: "LinearTextTaxiFareTask",
    data: { a, b, x, y },
    answer: y,
  };
}

export function renderTask({ data }) {
  const { a, b, x } = data;
  return (
    <>
      <p>
        Oplata za kurs taxi sklada sie z oplaty startowej i stawki za kazdy
        kilometr.
      </p>
      <p>
        Oplata startowa: <InlineMath math={`${b}`} /> zl, stawka:{" "}
        <InlineMath math={`${a}`} /> zl/km.
      </p>
      <p>
        Oblicz cene kursu o dlugosci <InlineMath math={`${x}`} /> km.
      </p>
    </>
  );
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span>
        <InlineMath math={"\\text{cena}="} />
      </span>
      <FractionInput
        value={userAnswer || ""}
        onChange={onChange}
        disabled={disabled}
        label={"\\text{cena}"}
        suffixLatex={String.raw`\text{zl}`}
        compactPreview={true}
      />
    </div>
  );
}

export function checkAnswer(task, userAnswer) {
  const parsed =
    typeof userAnswer === "object" && userAnswer !== null
      ? userAnswer.parsed
      : Number(userAnswer);

  if (parsed == null || Number.isNaN(parsed)) return false;
  return Math.abs(parsed - task.answer) < 0.01;
}

export function renderAnswer({ answer }) {
  return <InlineMath math={`\\text{cena}=${formatMoney(answer)}\\ \\text{zl}`} />;
}

export function renderExplanation({ data }) {
  const { a, b, x, y } = data;
  return (
    <div className="space-y-3">
      <p>
        <b>Krok 1:</b> Tworzymy model liniowy:
      </p>
      <BlockMath math={"f(x)=ax+b"} />
      <BlockMath math={`f(x)=${a}x+${b}`} />
      <p>
        <b>Krok 2:</b> Podstawiamy <InlineMath math={`x=${x}`} />:
      </p>
      <BlockMath math={`f(${x})=${a}\\cdot ${x}+${b}=${y}`} />
      <BlockMath math={`\\text{Odpowiedz: }${formatMoney(y)}\\ \\text{zl}`} />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer) return <i>(brak odpowiedzi)</i>;
  const raw =
    typeof userAnswer === "object" && userAnswer !== null
      ? userAnswer.raw
      : userAnswer;
  if (!raw && raw !== 0) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={`\\text{cena}=${String(raw)}\\ \\text{zl}`} />;
}
